// Helpers para enviar pelo WhatsApp via link (wa.me) — sem integração/servidor.

// Normaliza o número para o formato do wa.me (só dígitos, com DDI). Assume Brasil (55)
// quando o número vem só com DDD (10–11 dígitos).
export function normalizarTelefone(num?: string | null): string {
  const d = (num || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.length <= 11) return '55' + d; // DDD + número → prefixa 55
  return d;                             // já tem DDI
}

function limparMensagem(texto: string): string {
  return texto
    .normalize('NFC')
    .replace(/\bteste\s+lek+[aã]o\b[\s.!?,-]*/gi, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

// Monta o link wa.me com a mensagem (texto). O WhatsApp abre no contato do número.
export function linkWhatsapp(num: string | null | undefined, texto: string): string {
  const fone = normalizarTelefone(num);
  const msg = encodeURIComponent(limparMensagem(texto));
  return fone ? `https://wa.me/${fone}?text=${msg}` : `https://wa.me/?text=${msg}`;
}
